"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandLogos = BrandLogos;
exports.logos = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colours = require("../../fuse-colours/src/colours");
var logos = _interopRequireWildcard(require("./logos/index"));
exports.logos = logos;
var _excluded = ["alt", "brand", "dataTestId", "href"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  alt: _propTypes["default"].string,
  brand: _propTypes["default"].oneOf(['LittlewoodsRound', 'LittlewoodsRoundBasic', 'LittlewoodsRoundWhite', 'LittlewoodsStrip', 'LittlewoodsStripWhite', 'TakeThree', 'TakeThreeWhite', 'TakeThreeStacked', 'VeryPay', 'VeryPayBoxPinkV1', 'VeryPayBoxWhiteV1', 'VeryPayWhite', 'VeryPrimary', 'ParcelconnectRed', 'ParcelconnectWhite']),
  dataTestId: _propTypes["default"].string,
  href: _propTypes["default"].string
};
var defaultProps = {
  alt: 'Very Primary logo',
  brand: 'VeryPrimary',
  dataTestId: null,
  href: undefined
};
var StyledBrandLink = _styledComponents["default"].a.withConfig({
  displayName: "brand-logos__StyledBrandLink",
  componentId: "sc-1nnxb7o-0"
})(["", ""], function (_ref) {
  var width = _ref.width;
  // Check if width is passed as number only or as px or % value
  var linkWidth = /[a-zA-Z%]/.test(width) ? width : "".concat(width, "px");
  return "\n            display: inline-flex;\n            height: auto;\n            max-width: 100%;\n            position: relative;\n            width: ".concat(width ? linkWidth : "100%", ";\n\n            &:active,\n            &:focus {\n                outline: 2px solid ").concat(_colours.Colours.functional.focus, ";\n                outline-offset: 0;\n            }\n\n            img {\n                width: 100%;\n                height: 100%;\n            }\n\n            /* The below inserts minimum tabbable area to the image */\n            &:before {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: block;\n\t\t\t\tmin-height: 44px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\tmin-width: 44px;\n\t\t\t\twidth: 100%;\n\t\t\t}\n        ");
});
function BrandLogos(_ref2) {
  var alt = _ref2.alt,
    brand = _ref2.brand,
    dataTestId = _ref2.dataTestId,
    href = _ref2.href,
    props = _objectWithoutProperties(_ref2, _excluded);
  var CurrentLogo = logos[brand];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, href && /*#__PURE__*/_react["default"].createElement(StyledBrandLink, _extends({
    className: "fuse-brand-logos",
    "data-testid": dataTestId,
    href: href
  }, props), /*#__PURE__*/_react["default"].createElement("img", {
    className: "fuse-brand-logos__image",
    alt: alt,
    src: "data:image/svg+xml,".concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(CurrentLogo, null))))
  })), !href && /*#__PURE__*/_react["default"].createElement("img", _extends({
    className: "fuse-brand-logos fuse-brand-logos__image",
    alt: alt,
    "data-testid": dataTestId,
    src: "data:image/svg+xml,".concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(CurrentLogo, null))))
  }, props)));
}
BrandLogos.propTypes = propTypes;
BrandLogos.defaultProps = defaultProps;
var _default = exports["default"] = BrandLogos;